/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'basic/tv-1214282': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M18 6h-3.59l2.3-2.29a1 1 0 10-1.42-1.42L12 5.54l-1.17-2a1 1 0 10-1.74 1L10 6H6a3 3 0 00-3 3v8a3 3 0 003 3v1a1 1 0 002 0v-1h8v1a1 1 0 002 0v-1a3 3 0 003-3V9a3 3 0 00-3-3zm1 11a1 1 0 01-1 1H6a1 1 0 01-1-1V9a1 1 0 011-1h12a1 1 0 011 1z"/>'
  }
})
